import { relative } from 'path'
import React from 'react'
import { serverForImages } from '../../config'
import { IArticleContent } from '../../interfaces/article'

interface IYoutubeVideoItemProps {
  url: string,
  title: string,
}

const VideoYoutubeItem: React.FC<IYoutubeVideoItemProps> = ({ url, title }) => {
  return (
    <div className='w-full flex justify-center pb-10 l:pb-20 xl:pb-0'>
      <div className='w-full xl:w-1/2'>
        <div style={{
          overflow: 'hidden',
          paddingBottom: '56.25%',
          position: 'relative',
          height: 0
        }} >
          <iframe style={{
            left: 0,
            top: 0,
            height: '100%',
            width: '100%',
            position: 'absolute'
          }}
            width="853"
            height="480"
            src={`https://www.youtube.com/embed/${url}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={title}
          />
        </div>
      </div>
    </div>
  )
}

export default VideoYoutubeItem
